import { useIntl } from 'react-intl';

import type { TooltipContentProps } from 'recharts';
import { safeFormatMessage } from 'src/utils/intl';
import type { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent';

export default function StatisticTooltip<TValue extends ValueType, TName extends NameType>({
    active,
    payload,
    label,
}: TooltipContentProps<TValue, TName>) {
    const { formatMessage, formatNumber } = useIntl();

    if (active && payload && payload.length) {
        return (
            <div className="w-full max-w-56 rounded-sm border bg-white p-2 text-sm shadow-xs">
                <p className="font-medium text-gray-500">{label}</p>
                {payload.map((entry) => {
                    return (
                        <p key={Math.random()} className="font-medium text-gray-800" style={{ color: entry.color }}>
                            {safeFormatMessage(formatMessage, entry.name?.replaceAll('_', '-'), String(entry.name))}:{' '}
                            {entry.name && entry.dataKey === 'amount'
                                ? formatNumber(Number(entry.value) / 100, {
                                      style: 'currency',
                                      currency: entry?.payload?.currency,
                                  })
                                : entry.value}
                        </p>
                    );
                })}
            </div>
        );
    }

    return null;
}
